import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  useTheme,
} from '@mui/material';
import { Trash2 } from 'lucide-react';
import { Organisation } from '../../types/organization';
import { formatDate } from '../../utils/dateUtils';

interface OrganizationsTableProps {
  organizations: Organisation[];
  onEdit?: (org: Organisation) => void;
  onDelete?: (id: string) => void;
  onSelect?: (org: Organisation) => void;
  showActions?: boolean;
}

export default function OrganizationsTable({
  organizations,
  onDelete,
  onSelect,
  showActions = true,
}: OrganizationsTableProps) {
  const theme = useTheme();

  return (
    <Paper elevation={0} sx={{ border: `1px solid ${theme.palette.divider}`, borderRadius: 2 }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ px: 3, py: 1, color: theme.palette.text.secondary }}>
                Company Name
              </TableCell>
              <TableCell sx={{ py: 1, color: theme.palette.text.secondary }}>Plan Type</TableCell>
              <TableCell sx={{ py: 1, color: theme.palette.text.secondary }}>
                Contact Email
              </TableCell>
              <TableCell sx={{ py: 1, color: theme.palette.text.secondary }}>Created At</TableCell>
              {showActions && (
                <TableCell align="right" sx={{ px: 3, py: 1, color: theme.palette.text.secondary }}>
                  Actions
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {organizations.map(org => (
              <TableRow
                key={org.id}
                hover
                onClick={() => onSelect?.(org)}
                sx={{
                  cursor: 'pointer',
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell sx={{ px: 3, fontSize: 16, fontWeight: 500 }}>
                  {org.companyName}
                </TableCell>
                <TableCell> {org.planType} </TableCell>
                <TableCell>{org.client.email}</TableCell>
                <TableCell>{formatDate(org.createdAt)}</TableCell>
                {showActions && (
                  <TableCell align="right" sx={{ px: 3 }}>
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={e => {
                          e.stopPropagation();
                          onDelete?.(org.id);
                        }}
                      >
                        <Trash2 size={16} />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
